import { Signal } from '@angular/core';
import { Country } from '@finxone-platform/shared/services';
import { UiZoneWidgetAttributeConfig, baseCssConfigStyle } from '@finxone-platform/shared/sys-config-types';
import { Observable } from 'rxjs';

/**
 * DI seam exposing the slice of the web frontend's `ConfigService` that ui-components
 * widgets depend on. The web frontend provides the concrete `ConfigService` against this
 * token (via `useExisting`) so the library never imports the application directly.
 */
export abstract class WidgetConfigAccessor {
  /** Reactive map of the global CSS variables applied to the active workflow theme. */
  abstract readonly globalCssVariables: Signal<Record<string, string>>;

  /** Resolves the base CSS style for the requested properties of a widget configuration. */
  abstract getSpecificBaseCssStyle(
    widgetConfiguration: UiZoneWidgetAttributeConfig,
    propertyName: Array<string>,
  ): baseCssConfigStyle;

  /** Streams the supported country list used by the phone-number widget. */
  abstract getCountries(): Observable<Country[]>;
}
